"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntrustOtherContractedEntities = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.EntrustOtherContractedEntities = {
    priority: 1,
    label: 'fields.payload.mor_group_answers.entrust_other_contracted_entities.label',
    fallbackLabel: 'Do you entrust any aspects of your AML, CTF, and Sanctions Program to other contracted parties, such as payment facilitators, affiliates, distributors, or platforms, for example, during onboarding, in the following contractual arrangement: Klarna > Your Entity > Payment Facilitator > Merchant',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.Boolean,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
